<template>
  <div class="page-container" v-if="data">
    <!-- 1. 基本信息卡片 -->
    <div class="card info-card">
      <div class="info-row">
        <span class="info-item">姓名：<span>{{ data.user.name }}</span></span>
        <span class="info-item">性别：<span>{{ data.user.sex }}</span></span>
      </div>
      <div class="info-row">
        <span class="info-item">年龄：<span>{{ data.user.age }}岁</span></span>
        <span class="info-item">身高：<span>{{ data.user.height }}cm</span></span>
      </div>
      <div class="info-row">
        <span class="info-item">既往病史：<span>{{ data.user.jwbs }}</span></span>
      </div>
      <div class="info-row date-row">
        <span class="info-item">检测时间：<span>{{ data.user.date }}</span></span>
      </div>
    </div>

    <!-- 2. 图表区域 (柱状图对比) -->
    <template v-if="data.last && data.last.length > 0">
      <div class="section-title">健康评估对比</div>
      <div class="card chart-card">
        <div class="bar-chart-container" ref="barChartCanvas">
          <!-- <canvas ref="barChartCanvas" class="bar-chart-canvas"></canvas> -->
        </div>
      </div>
    </template>

    <div class="container">
      <div class="header-card">
        <div class="header-title-wrap">
          <img class="icon-shield" src="https://pro-yeahgo-oss.yeahgo.com/icon/20260602/未标题-1_0007_图层-1.png?v=6"
            style="width: 100%; height: auto" />
        </div>
      </div>

      <div class="table-wrapper">
        <div class="table-container">
          <div class="table-thead">
            <div class="th th-item">评估项目</div>
            <div class="th th-range">正常范围</div>
            <div class="th th-current">本次评估</div>
            <div class="th th-result">结果</div>
            <div class="th th-last">上次评估</div>
            <div class="th th-trend">趋势</div>
          </div>

          <div class="table-tbody">
            <div v-for="item in data.analysis" :key="item.name" class="table-tr">
              <div class="td td-item">
                <img class="item-icon" :src="item.logo" style="width: 40rpx; height: auto" />
                <span class="item-name">{{ item.name }}</span>
              </div>
              <div class="td td-range">
                <span>{{ item.range[0] }}</span>
                <span>-</span>
                <span>{{ item.range[1] }}</span>
              </div>
              <div class="td td-current">{{ item.currSituation || '' }}</div>
              <div class="td td-result">
                <div class="status-tag" :class="item.statusClass" v-html="item.result"></div>
              </div>
              <div class="td td-last">{{ item.lastSituation || '' }}</div>
              <div class="td td-trend">{{ item.trend || '' }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 3. 个人情况综合分析及建议 -->
    <div class="section-title">健康评估个人建议</div>
    <div class="card summary-card">
      <!-- <div class="summary-text" v-html="data.device.title"></div> -->
      <div class="blue-box">
        <div class="blue-box-content">
          <div v-for="(bullet, idx) in data.device.list" :key="idx" class="bullet" v-html="bullet.val"></div>
        </div>
      </div>
    </div>

    <!-- 4. 健康评估七大维度解析 -->
    <div class="section-title">健康评估七大维度解析</div>
    <div class="dimension-list">
      <div v-for="(dim, dimIdx) in dimensions" :key="dim.id" class="card dim-card">
        <div class="dim-header" @click="toggleExpand(dimIdx)">
          <div class="dim-title-group">
            <img class="dim-icon" :src="dim.icon" style="width: 48rpx; height: auto" />
            <span class="dim-title">{{ dim.title }}</span>
          </div>
          <div :class="['arrow', dim.isExpanded ? 'arrow-up' : 'arrow-down']"></div>
        </div>

        <div v-if="dim.isExpanded" class="dim-content">
          <div class="dim-overview">{{ dim.overview }}</div>

          <div class="dim-advice">
            <div class="advice-title">· 分数解读：</div>
            <div v-for="(dietItem, dIdx) in dim.diet" :key="dIdx" class="advice-text">{{ dietItem }}</div>
          </div>

          <div class="dim-advice">
            <div class="advice-title">· 对应通用特征：</div>
            <div v-for="(lifeItem, lIdx) in dim.lifestyle" :key="lIdx" class="advice-text">{{ lifeItem }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 5. 底部免责声明 -->
    <div class="footer-tips">{{ data.disclaimer }}</div>
    <div class="footer-tips">{{ data.disclaimer2 }}</div>
    <div style="display: none;">{{data.aIGCID}}</div>
  </div>
</template>

<script>

(function () {
  // 标准视口配置内容
  const VIEWPORT_CONTENT = 'width=device-width, initial-scale=1.0';

  /**
   * 确保页面存在且仅存在一个正确配置的viewport meta标签
   */
  function ensureViewport() {
    // 获取所有viewport meta标签（静态NodeList，安全遍历）
    const viewportMetas = document.querySelectorAll('meta[name="viewport"]');

    if (viewportMetas.length > 0) {
      // 更新第一个meta标签的content属性为标准内容
      viewportMetas[0].setAttribute('content', VIEWPORT_CONTENT);

      // 移除多余的viewport meta标签（保留第一个）
      for (let i = 1; i < viewportMetas.length; i++) {
        const extraMeta = viewportMetas[i];
        extraMeta.parentNode && extraMeta.parentNode.removeChild(extraMeta);
      }
    } else {
      // 不存在viewport meta标签时动态创建
      const meta = document.createElement('meta');
      meta.name = 'viewport';
      meta.content = VIEWPORT_CONTENT;

      // 获取head元素（兼容极端情况）
      const head = document.head || document.getElementsByTagName('head')[0];
      if (head) {
        head.appendChild(meta);
      } else {
        // 极少数文档无head时，创建并插入到根元素最前
        const newHead = document.createElement('head');
        const root = document.documentElement;
        root.insertBefore(newHead, root.firstChild);
        newHead.appendChild(meta);
      }
    }
  }

  // 立即执行，确保在页面渲染前完成视口设置
  ensureViewport();
})();

import * as echarts from 'echarts';
import { post } from '@/utils/request';
import { Dialog, Toast } from 'vant';

export default {
  data() {
    return {
      data: null,
      dimensions: [
        {
          id: 1,
          icon: "https://pro-yeahgo-oss.yeahgo.com/icon/20260521/未标题-2_0007_7.png",
          title: "1.细胞活跃度",
          overview:
            "指人体全身细胞基础活力、自我修复、新陈代谢的核心基础，是所有身体机能的根本底盘。",
          diet: [
            "高分：精力充足、不易疲惫、身体修复快、气色状态好。",
            "低分：容易莫名乏力、懒得动、身体修复慢、常年亚健康困倦。",
          ],
          lifestyle: [
            "亚健康疲劳：总觉得睡不够、没精神。",
            "恢复慢：感冒老不好，或者术后、产后身体虚弱恢复慢。",
            "早衰迹象：皮肤松弛、身体机能下降快。",
          ],
          isExpanded: true, // 默认展开第一个
        },
        {
          id: 7,
          icon: "https://pro-yeahgo-oss.yeahgo.com/icon/20260521/未标题-2_0013_1.png",
          title: "2.免疫力",
          overview:
            "指身体自我防御、抗病毒、防感冒、自身自愈抵抗的综合体质水平。",
          diet: [
            "高分：很少感冒生病、小毛病自愈快、整体体质底子强。",
            "低分：换季易感冒、容易反复小毛病、抵抗力弱、易被外界病菌侵扰。",
          ],
          lifestyle: [
            "反复感冒/流感：一到换季就生病。",
            "慢性炎症：反复的口腔溃疡、咽喉炎、妇科炎症等。",
            "过敏体质：免疫系统“敌我不分”，对花粉、粉尘过度反应。",
          ],
          isExpanded: true,
        },
        {
          id: 3,
          icon: "https://pro-yeahgo-oss.yeahgo.com/icon/20260521/未标题-2_0009_5.png",
          title: "3.循环系统",
          overview: "指血管弹性、血液流通、全身气血输送、手脚末梢循环健康水平。",
          diet: [
            "高分：手脚不冰凉、气血通畅、少有头晕麻木、供血充足。",
            "低分：常年手脚冰凉、久坐胸闷、偶尔头晕、末梢循环差。",
          ],
          lifestyle: [
            "心脑血管隐患：高血压、高血脂、血液粘稠。",
            "肢体末端循环差：手脚冰凉、四肢麻木。",
            "头晕头痛：脑供血不足引起的眩晕。",
            "静脉曲张/水肿：体液循环不畅。",
          ],
          isExpanded: true,
        },
        {
          id: 5,
          icon: "https://pro-yeahgo-oss.yeahgo.com/icon/20260521/未标题-2_0011_3.png",
          title: "4.抗氧化",
          overview:
            "指身体清除自由基、抵抗细胞老化、减少氧化损伤、抗炎抗衰的核心能力。",
          diet: [
            "高分：气色年轻、不易衰老、抗疲劳强、身体抗炎状态好。",
            "低分：容易暗沉苍老、易疲劳、体内氧化损伤堆积、亚健康偏重。",
          ],
          lifestyle: [
            "机体老化：皮肤松弛、老年斑、器官功能退化。",
            "退行性疾病：如帕金森、阿尔茨海默症（老年痴呆）的风险因素。",
            "慢性氧化应激：长期炎症、疲劳综合征。",
          ],
          isExpanded: true,
        },
        {
          id: 6,
          icon: "https://pro-yeahgo-oss.yeahgo.com/icon/20260521/未标题-2_0012_2.png",
          title: "5.代谢能力",
          overview:
            "指身体能量消耗、体内毒素垃圾排出、脂类代谢、肠胃运化吸收能力。",
          diet: [
            "高分：排便规律、不易发胖积食、饭后不犯困、身体代谢通畅。",
            "低分：排便不规律、易发胖水肿、饭后困倦、代谢淤堵湿气重。",
          ],
          lifestyle: [
            "代谢综合征：肥胖、高血糖、高血脂、脂肪肝。",
            "消化系统问题：便秘、消化不良、食欲不振。",
            "内分泌失调：甲状腺功能异常等。",
          ],
          isExpanded: true,
        },
        {
          id: 4,
          icon: "https://pro-yeahgo-oss.yeahgo.com/icon/20260521/未标题-2_0010_4.png",
          title: "6.神经系统",
          overview:
            "指管控睡眠质量、情绪心态、记忆力、脑神经放松与抗压调节能力。",
          diet: [
            "高分：入睡快、睡得安稳、情绪平稳、不易烦躁焦虑、记忆力好。",
            "低分：入睡困难、多梦易醒、健忘心烦、精神紧绷、容易失眠。",
          ],
          lifestyle: [
            "睡眠障碍：失眠、多梦、易醒、早醒。",
            "情绪问题：焦虑、抑郁、神经衰弱。",
            "神经性疼痛：偏头痛、三叉神经痛、坐骨神经痛。",
            "认知功能下降：记忆力减退、注意力不集中。",
          ],
          isExpanded: true,
        },
        {
          id: 2,
          icon: "https://pro-yeahgo-oss.yeahgo.com/icon/20260521/未标题-2_0008_6.png",
          title: "7.呼吸系统",
          overview: "指肺部换气功能、血氧交换能力、呼吸道及肺部整体健康状态。",
          diet: [
            "高分：呼吸顺畅、爬楼快走不气短、换季不易咳嗽痰多。",
            "低分：偶尔胸闷气短、容易咽干、换季易咳喘、肺活量偏弱。",
          ],
          lifestyle: [
            "气道敏感/阻塞：慢性支气管炎、哮喘、肺气肿。",
            "缺氧症状：胸闷、心慌、头晕、嗜睡（特别是打呼噜严重的人）。",
            "肺功能下降：老年性肺功能减退、尘肺等。",
          ],
          isExpanded: true,
        },
      ],
      chartInstance: null
    };
  },
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  mounted() {
    // if (this.data.last && this.data.last.length > 0) {
    //   this.$nextTick(() => {
    //     this.initChart();
    //   });
    // }
    post({
      url: '/healthy/open/hyoxy/reports', data: {
        ...this.$route.query
      }
    }).then((response) => {
      const data = response.data;
      data.analysis = data.analysis.map((item) => ({
        ...item,
        range: item.range.split("-"),
      }));
      this.data = data;
      this.$nextTick(() => {
        this.initChart();
      })

      if (data.tip) {
        Dialog({ message: data.tip.replace(/\\n/g,'\n'), title: '温馨提示' })
          .then(_ => {
            data.tips1 && Toast(data.tips1)
          })
      } else if (data.tips1) {
        Toast(data.tips1)
      }

    });
    window.addEventListener('resize', this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
    if (this.chartInstance) {
      this.chartInstance.dispose();
      this.chartInstance = null;
    }
  },
  methods: {
    toggleExpand(index) {
      this.dimensions[index].isExpanded = !this.dimensions[index].isExpanded;
    },
    initChart() {
      const data = this.data
      const canvasElem = this.$refs.barChartCanvas;
      if (!canvasElem) return;
      if (this.chartInstance) {
        this.chartInstance.dispose();
      }

      this.chartInstance = echarts.init(canvasElem);

      const option = {
        color:
          data.type == 3
            ? ["#0065D6", "#22AC38"]
            : data.type == 2
              ? ["#85BF49"]
              : ["#0065D6"], // 蓝色和绿色
        legend: {
          data: data.type == 3 ? ["上次评估", "本次评估"] : ["本次评估"],
          bottom: 20,
          selectedMode: false,
          // show: true,
        },
        grid: {
          left: "9%",
          right: "4%",
          bottom: "13%",
          top: "5%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: data.curr.map((item) => item.name),
          axisLabel: {
            interval: 0,
            rotate: 45,
          },
        },
        yAxis: {
          type: "value",
          max: 100,
          interval: 20,
          axisLabel: {
            show: false,
          },
        },
        series: [],
      };

      if (data.type == 3 && data.last) {
        option.series.push({
          name: "上次评估",
          type: "bar",
          data: data.last.map((item) => item.val),
          barWidth: data.type == 3 ? 10 : 20,
        });
      }

      if (data.curr) {
        option.series.push({
          name: "本次评估",
          type: "bar",
          data: data.curr.map((item) => item.val),
          barWidth: data.type == 3 ? 10 : 20,
        });
      }
      this.chartInstance.setOption(option);
    },
    handleResize() {
      if (this.chartInstance) {
        this.chartInstance.resize();
      }
    }
  }
};
</script>

<style scoped lang="scss">
/* 页面整体背景 */
.page-container {
  background-color: #DDECFF;
  min-height: 100vh;
  padding: 15px;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Helvetica,
    Segoe UI, Arial, Roboto, 'PingFang SC', 'miui', 'Hiragino Sans GB', 'Microsoft Yahei',
    sans-serif;
}

.table-wrapper {
  padding: 8px;
  border: 1px solid #e1e9f7;
  border-radius: 8px;
  margin-top: -5px;
  position: relative;
  z-index: 1;
  background: #fff;
}

/* 通用卡片样式 */
.card {
  background: #ffffff;
  border-radius: 10px;
  padding: 15px;
  margin-bottom: 15px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.03);
}

/* 1. 基本信息卡片 */
.info-row {
  display: flex;
  margin-bottom: 8px;
  font-size: 14px;
  color: #333;
}

.info-item {
  flex: 1;

  text {
    font-weight: bold;
  }
}

.date-row {
  margin-top: 10px;
  margin-bottom: 0;
  // color: #666;
  // font-size: 26rpx;
}

/* 2. 模拟图表区域 */
.chart-card {
  height: 250px;
}

.bar-chart-container {
  display: flex;
  height: 250px;
  width: 100%;
}

.y-axis {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 10px;
  color: #999;
  padding-right: 7.5px;
  border-right: 1px solid #eee;
}

.bars-area {
  flex: 1;
  display: flex;
  justify-content: space-around;
  align-items: flex-end;
  padding-left: 5px;
  padding-bottom: 25px;
  /* 为倾斜文字留空间 */
  position: relative;
}

.bar-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 12%;
  height: 100%;
  position: relative;
}

.bar {
  width: 12px;
  height: 100%;
  background-color: #f0f0f0;
  border-radius: 2px 2px 0 0;
  display: flex;
  align-items: flex-end;
}

.bar-fill {
  width: 100%;
  background-color: #1976D2;
  /* 主题蓝 */
  border-radius: 2px 2px 0 0;
  transition: height 0.5s ease;
}

.bar-label {
  position: absolute;
  bottom: -20px;
  font-size: 9px;
  color: #666;
  transform: rotate(-45deg);
  /* 文字倾斜 */
  white-space: nowrap;
}

/* 模块标题 */
.section-title {
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  // color: #333;
  margin: 20px 0 10px;
}

/* 3. 综合分析卡片 */
.summary-text {
  font-size: 14px;
  color: #333;
  line-height: 1.6;
  display: block;
  margin-bottom: 10px;
}

.blue-box {
  background-color: #DFF0FF;
  border-radius: 6px;
  padding: 12px;
}

.blue-box-title {
  font-size: 14px;
  font-weight: bold;
  color: #1976D2;
  margin-bottom: 6px;
}

.bullet {
  font-size: 13px;
  // color: #555;
  line-height: 1.5;
  margin-bottom: 5px;
}

/* 4. 七大维度解析 (手风琴) */
.dim-card {
  padding: 0;
  /* 内部控制padding */
  overflow: hidden;
}

.dim-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 15px 10px;
}

.dim-title-group {
  display: flex;
  align-items: center;
}

.dim-icon {
  width: 25px;
  // font-size: 36rpx;
  margin-right: 6px;
}

.dim-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

/* 箭头样式实现 */
.arrow {
  width: 8px;
  height: 8px;
  border-top: 2px solid #999;
  border-right: 2px solid #999;
  transition: transform 0.3s;
}

.arrow-down {
  transform: rotate(135deg);
}

.arrow-up {
  transform: rotate(-45deg);
}

.dim-content {
  padding: 0 15px 15px;
  // border-top: 1rpx solid #f0f0f0;
  margin-top: -5px;
}

.dim-overview {
  font-size: 14px;
  color: #444;
  line-height: 1.6;
  margin-top: 10px;
  margin-bottom: 10px;
}

.advice-title {
  font-size: 14px;
  font-weight: bold;
  // color: #333;
  margin-top: 8px;
}

.advice-text {
  font-size: 13px;
  // color: #666;
  line-height: 1.5;
  margin-top: 3px;
}

/* 5. 底部免责声明 */
.footer-tips {
  font-size: 11px;
  color: #999;
  line-height: 1.6;
  text-align: justify;
  padding: 10px 5px 10px;
}

ec-canvas {
  width: 100%;
  height: 100%;
}


.container {
  background: #ffffff;
  border-radius: 12px;
  // border: 4rpx solid #b3d1ff;
  // box-shadow: 0 8rpx 20rpx rgba(24, 114, 243, 0.05);
  overflow: hidden;
  padding: 8px;
}

/* 头部样式 */
.header-card {
  // background: linear-gradient(135deg, #2575fc 0%, #1a5ed4 100%);
  border-radius: 8px 8px 0 0;
  // padding: 30rpx 40rpx;
  // display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-title-wrap {
  border-radius: 8px 8px 0 0;
  overflow: hidden;
  // display: flex;
  // align-items: center;

}

.icon-shield {
  width: 100%;
  // margin-right: 20rpx;
}

.header-title {
  color: #ffffff;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 1px;
}

.header-right {
  display: flex;
  align-items: center;
}

.icon-wave {
  width: 50px;
  height: 20px;
  margin-right: 12px;
}

.icon-chart {
  width: 22px;
  height: 22px;
}

/* 表格通用布局 (采用百分比严格控制列宽) */
.table-container {
  width: 100%;
  border: 1px solid #e1e9f7;
  border-top: none;
  border-radius: 8px;
  overflow: hidden;
}

.table-thead {
  display: flex;
  background-color: #1a73e8;
}

.th {
  color: #ffffff;
  font-size: 10px;
  font-weight: 500;
  text-align: center;
  padding: 6px 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px solid rgba(255, 255, 255, 0.2);
  box-sizing: border-box;
}

.th:last-child {
  border-right: none;
}

/* 列宽比例分配 */
.th-item,
.td-item {
  width: 26%;
}

.th-range,
.td-range {
  width: 16%;
}

.th-current,
.td-current {
  width: 16%;
}

.th-result,
.td-result {
  width: 16%;
}

.th-last,
.td-last {
  width: 16%;
}

.th-trend,
.td-trend {
  width: 10%;
}

.td-result {
  font-size: 10px !important;
}

/* 表体行样式 */
.table-tbody {
  background-color: #ffffff;
}

.table-tr {
  display: flex;
  border-bottom: 1px solid #eef3fa;
}

.table-tr:last-child {
  border-bottom: none;
}

.table-tr:nth-child(even) {
  background-color: #f9fbfd;
  /* 隔行换色，提高阅读性 */
}

.td {
  font-size: 10px;
  text-align: center;
  padding: 5px 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px solid #eef3fa;
  min-height: 22px;
  box-sizing: border-box;
  color: #0165D7;
}

.td:last-child {
  border-right: none;
}

/* 评估项目列特殊处理 */
.td-item {
  justify-content: flex-start;
  // padding-left: 10rpx;
  box-sizing: border-box;
}

.item-icon {
  width: 15px;
  height: 15px;
  margin-right: 5px;
  flex-shrink: 0;
}

.item-name {
  font-size: 10px;
  color: #0165D7;
}

.td-range {
  color: #0165D7;
  flex-direction: column;
}
</style>